import { z } from 'zod';
// Base validation and DTO type
export const meetingBodyStaffMemberBaseSchema = z.object({
    userId: z
        .number('A user is required')
        .describe('The government user serving as staff. Required for create.'),
    title: z
        .string('Title is required')
        .min(1, 'Title is required')
        .max(300, 'Title must be less than 300 characters')
        .describe('The role this user serves in, e.g. "City Clerk". Required for create.'),
});
// Create validation and DTO type
export const meetingBodyStaffMemberCreateSchema = meetingBodyStaffMemberBaseSchema;
// Update validation and DTO type
export const meetingBodyStaffMemberUpdateSchema = meetingBodyStaffMemberBaseSchema.partial();
// Reorder validation and DTO type
export const meetingBodyStaffMemberReorderSchema = z.object({
    meetingBodyStaffMemberIds: z
        .array(z.number(), 'Staff member IDs are required')
        .describe('List of staff member IDs where position in the array determines their display order. All of the meeting body’s staff members must be provided in the desired order.'),
});
